import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export const AssigneeSelect = ({ value, onChange, testid }) => {
  const { user } = useAuth();
  const [users, setUsers] = useState([]);
  useEffect(() => { if (user.role === "BROKER") api.get("/users").then((r) => setUsers(r.data)).catch(() => {}); }, [user.role]);
  if (user.role !== "BROKER") return null;
  return (
    <div>
      <Label className="text-xs">Sorumlu</Label>
      <Select value={value || user.id} onValueChange={onChange}>
        <SelectTrigger data-testid={testid}><SelectValue /></SelectTrigger>
        <SelectContent>{users.map((u) => <SelectItem key={u.id} value={u.id}>{u.full_name}</SelectItem>)}</SelectContent>
      </Select>
    </div>
  );
};
